// External dependencies.
import $ from "jquery";

/**
 * StoreLogosCarousel class.
 *
 * @since 0.4.0
 * @class StoreLogosCarousel
 */
class StoreLogosCarousel {
    /**
     * Creates an instance of StoreLogosCarousel.
     * 
     * @since 0.4.0
     * @memberof StoreLogosCarousel
     */
    constructor() {
        this.carousel = document.querySelector( '#ts-product-stores-gallery-carousel' );
        this.initCarousel = this.initCarousel.bind( this );

        this.initCarousel();
    }

    /**
     * Inits the carousel.
     *
     * @since 0.4.0
     * @returns
     * @memberof StoreLogosCarousel
     */
    initCarousel() {
        if ( !this.carousel ) {
            return;
        }

        const settings = {
            adaptiveHeight: true,
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        arrows: true,
                        prevArrow: `<img src="${window.app.theme_file_uri}/assets/images/icon-angle-left.png" class="ts-slider__arrow ts-slider__arrow--prev">`,
                        nextArrow: `<img src="${window.app.theme_file_uri}/assets/images/icon-angle-right.png" class="ts-slider__arrow ts-slider__arrow--next">`,
                        dots: false,
                        slidesToShow: 5,
                        autoplay: true,
                        autoplaySpeed: 4000,
                        speed: 1000,
                    },
                },
                {
                    breakpoint: 1439,
                    settings: {
                        arrows: true,
                        prevArrow: `<img src="${window.app.theme_file_uri}/assets/images/icon-angle-left.png" class="ts-slider__arrow ts-slider__arrow--prev">`,
                        nextArrow: `<img src="${window.app.theme_file_uri}/assets/images/icon-angle-right.png" class="ts-slider__arrow ts-slider__arrow--next">`,
                        dots: false,
                        slidesToShow: 6,
                    },
                },
                {
                    breakpoint: 1559,
                    settings: "unslick",
                }
            ],
        };
        $( this.carousel ).slick( settings );
    };
}

export default StoreLogosCarousel;
